import React, { useEffect } from 'react';
import { constants as userConstants, records as userRecords } from '@saucelabs/sl-module-user';

const SCRIPT_ID = 'profitwell-js';
const ACCOUNT_CODE_ID_PARAM = 'user_id';
const AUTH_PARAM_NAME = 'data-pw-auth';

// Checks if profitwell.js was already added to the DOM (by another use of this component)
const isProfitwellAlreadyLoaded = () => {
  for (const script of document.scripts) { // eslint-disable-line no-restricted-syntax
    if (script.id === SCRIPT_ID) {
      return true;
    }
  }
  return false;
};

// From https://learn.profitwell.com/article/s3ew8syaas-profitwell-snippet-spa
const SNIPPET_BODY = `
  (function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
    a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
      s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
  })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');
`;

const ProfitwellHelper: React.FC<{
  profitwellApiTokenRow: string;
  user: userRecords.UserRecord;
}> = ({
  profitwellApiTokenRow,
  user,
}) => {
  useEffect(() => {
    if (!isProfitwellAlreadyLoaded()) {
      // profitwell dependency added dynamically to the body of the html
      const profitwellScript = document.createElement('script');
      profitwellScript.id = SCRIPT_ID;
      profitwellScript.setAttribute(AUTH_PARAM_NAME, profitwellApiTokenRow);
      profitwellScript.innerHTML = SNIPPET_BODY;

      document.body.appendChild(profitwellScript);
      console.debug('[ProfitWell] Injected in-app snippet');
    }
  }, []);

  useEffect(() => {
    if (
      user?.getOrgUserType() === userConstants.USER_TYPE_SUBSCRIBED_EXTERNAL &&
      user.isOrgAdmin()
    ) {
      window.profitwell('start', { [ACCOUNT_CODE_ID_PARAM]: user.organization.id });
      console.debug(`[ProfitWell] Initialized with ${ACCOUNT_CODE_ID_PARAM}=${user.organization.id}`);
    }
  }, [user]);

  return null;
};

export default ProfitwellHelper;
